




export const WashListPage = () => {
  return (
    <div>
      <h1>Wash List Page</h1>
      <p>This page will display a list of available washes.</p>
      {/* Add components or logic to display the wash list here */}
    </div>
  );
}